"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Dropdown_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Dropdown"));
var genIcon_1 = __importDefault(require("../../../utils/genIcon"));
var DropItem = /** @class */ (function (_super) {
    __extends(DropItem, _super);
    function DropItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setOnClick = function (event, props) {
            if (_this.props.href) {
                window.location.assign(_this.props.href);
            }
            if (_this.props.onClick) {
                _this.props.onClick(event, props);
            }
        };
        _this.genItemProps = function () {
            var _a = _this.props, onClick = _a.onClick, href = _a.href, description = _a.description, badgeColor = _a.badgeColor, icon = _a.icon, iconRoot = _a.iconRoot, active = _a.active, isBadged = _a.isBadged, badge = _a.badge, cleanedProps = __rest(_a, ["onClick", "href", "description", "badgeColor", "icon", "iconRoot", "active", "isBadged", "badge"]);
            return cleanedProps;
        };
        return _this;
    }
    DropItem.prototype.render = function () {
        var cleaned = this.genItemProps();
        return (React.createElement(Dropdown_1.default.Item, __assign({}, cleaned, { onClick: this.setOnClick }), this.renderContent()));
    };
    DropItem.prototype.renderBadgedIcon = function () {
        var _a = this.props, icon = _a.icon, iconRoot = _a.iconRoot, badge = _a.badge, badgeColor = _a.badgeColor, description = _a.description;
        if (icon) {
            if (badge) {
                return genIcon_1.default(icon, { root: iconRoot, description: description, size: 'medium', className: 'drop-icon' }, { content: badge, color: badgeColor });
            }
            else {
                return genIcon_1.default(icon, { root: iconRoot, description: description, size: 'medium', className: 'drop-icon' });
            }
        }
        return null;
    };
    DropItem.prototype.renderContent = function () {
        if (this.props.isBadged) {
            return (React.createElement("span", { className: "drop-badged-wrap" },
                this.renderBadgedIcon(),
                " ",
                React.createElement("span", { className: "drop-badged-text" }, this.props.description)));
        }
        else {
            return this.props.children;
        }
    };
    return DropItem;
}(react_1.Component));
exports.default = DropItem;
